// Purpose: external uploader API wrappers. No CSRF (anonymous flow). All
// paths now live under /api/public/dropbox — /d/:token is the SPA route
// served by nginx as index.html (the user-facing link), not an API path
// (fixed in Commit 5.6m; prior XHR to /d/:token hit the SPA fallback
// and returned HTML, which is how the quota widget rendered 'NaN GB').

import axios from 'axios';

export interface DropboxLandingMeta {
  label: string;
  maxFiles: number;
  maxSizeBytes: string;
  usedFiles: number;
  usedSizeBytes: string;
  remainingFiles: number;
  remainingSizeBytes: string;
  expiresAt: string | null;
}

export interface PresignResponse {
  fileId: string;
  uploadUrl: string;
  expiresAt: string;
  blobPath: string;
}

export async function getDropboxMeta(token: string): Promise<DropboxLandingMeta> {
  const res = await axios.get<DropboxLandingMeta>(`/api/public/dropbox/${token}/meta`, {
    withCredentials: false,
  });
  return res.data;
}

export async function presignDropboxFile(
  token: string,
  input: { originalFilename: string; sizeBytes: number; mimeType: string }
): Promise<PresignResponse> {
  const res = await axios.post<PresignResponse>(`/api/public/dropbox/${token}/presign`, input, {
    withCredentials: false,
  });
  return res.data;
}

export async function completeDropboxFile(
  token: string,
  fileId: string,
  rawDekBase64: string
): Promise<void> {
  await axios.post(
    `/api/public/dropbox/${token}/complete`,
    { fileId, rawDek: rawDekBase64 },
    { withCredentials: false }
  );
}

// Commit 8b.13: external-uploader error reporter. Counterpart to
// reportFileError in api/shares.ts.
export async function reportDropboxFileError(
  token: string,
  fileId: string,
  errorReason: string
): Promise<void> {
  await axios.post(
    `/api/public/dropbox/${token}/error`,
    { fileId, errorReason },
    { withCredentials: false }
  );
}
